import React from "react";
import { useTranslation } from "react-i18next";
import { Broadcast, TrendUp, TrendDown, Sparkle, Crown } from "@phosphor-icons/react";

const ICONS = { Broadcast, TrendUp, TrendDown, Sparkle, Crown };

export const WhyPicker = ({ options, value, onChange, testPrefix }) => {
  const { t } = useTranslation();
  return (
    <div className="grid grid-cols-2 gap-2">
      {options.map((o) => {
        const Icon = ICONS[o.icon];
        const active = value === o.key;
        return (
          <button
            key={o.key}
            type="button"
            data-testid={`${testPrefix}-${o.key}`}
            onClick={() => onChange(o.key)}
            className={`flex flex-col items-start gap-1.5 border p-3 text-left transition-colors duration-200 ${
              active
                ? "border-[#C58361] bg-[#C58361]/10"
                : "border-[#1F1F1F] bg-[#050505] hover:border-[#3A3A3A]"
            }`}
          >
            <Icon size={18} weight="duotone" className={active ? "text-[#C58361]" : "text-zinc-500"} />
            <span className={`text-xs leading-tight ${active ? "text-[#C58361]" : "text-zinc-300"}`}>
              {o.i18nKey ? t(o.i18nKey) : o.label}
            </span>
          </button>
        );
      })}
    </div>
  );
};
